module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['modal', 'animated', _vm.show ? 'is-active' : '']
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "account-wrapper"
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        return _vm.afterLeave()
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._l((_vm.context.$store.state.config.notifications.slice().reverse()), function(notification) {
    return [_c('div', {
      staticClass: "box"
    }, [_c('article', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(notification.user_name))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("moment")(notification.created_at, 'from')))]), _vm._v(" "), _c('br')]), _c('p', {
      domProps: {
        "innerHTML": _vm._s(notification.notification)
      }
    }), _vm._v(" "), _c('nav', {
      staticClass: "level"
    }, [_c('div', {
      staticClass: "level-left"
    }, [_c('a', {
      staticClass: "level-item",
      on: {
        "click": function($event) {
          return _vm.viewOccurrence(notification.id, notification.occurrence_id)
        }
      }
    }, [_vm._m(0, true)])])])])])])])]
  })], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-reply"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a5342a6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/notifications/Notifications.vue
// module id = 1064
// module chunks = 39